"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.share = exports.jdDoctor = exports.jdhshare = exports.getVersion = exports.Version = exports.wxShareInfo = void 0;
var seoLocationWatcher_1 = require("../seo/seoLocationWatcher");
var jssdk_1 = require("./jssdk");
// 分享的相关公共参数
exports.wxShareInfo = {
    title: "京东健康互联网医院：随时随地，寻医问药",
    content: "看全国顶级名医，挂稀缺专家号，购优质放心药。",
    imageUrl: "https://storage.jd.com/hospital/wxshareimg2.jpg",
};
/**
 * 2021-07-16 (完善注释)校验当前版本是否 大于 目标版本
 *    - 当前版本大于目标版本（既当前版本新于目标版本）true
 *    - 当前版本下于目标版本（既当前版本等于、或小于目标版本）false
 * @param {String} curV
 * @param {String} reqV
 * @returns {Boolean} flag
 */
function Version(curV, reqV) {
    if (curV == undefined || reqV == undefined) {
        return false;
    }
    var arr1 = curV.toString().split(".");
    var arr2 = reqV.toString().split("."); //将两个版本号拆成数字
    var minL = Math.min(arr1.length, arr2.length);
    var pos = 0; //当前比较位
    var diff = 0; //当前为位比较是否相等
    var flag = false; //逐个比较如果当前位相等则继续比较下一位
    while (pos < minL) {
        diff = parseInt(arr1[pos]) - parseInt(arr2[pos]);
        if (diff == 0) {
            pos++;
            continue;
        }
        else if (diff > 0) {
            flag = true;
            break;
        }
        else {
            flag = false;
            break;
        }
    }
    return flag;
}
exports.Version = Version;
/**
 * 获取京东医生app UA 版本号
 */
function getVersion() {
    // 区分iOS版本号
    var sUsrAg = window.navigator.userAgent;
    var edit = sUsrAg.split(";")[2]; // 经沟通安卓iOS都是固定位置
    return edit;
}
exports.getVersion = getVersion;
// 京东健康app分享
function jdhshare(options, optionsTmp) {
    var params = Object.assign({}, optionsTmp, options);
    var url = "openapp.jdhealth://virtual?params={\"category\":\"jump\",\"des\":\"share\",\"type\":\"111\",\"title\":\"".concat(params.title, "\",\"content\":\"").concat(params.content, "\",\"shareUrl\":\"").concat(params.shareUrl, "\",\"imageUrl\":\"").concat(params.imageUrl, "\",\"iconUrl\":\"").concat(params.iconUrl, "\",\"timeline_title\":\"\",\"qrparam\":null,\"keyparam\":null,\"channel\":\"\",\"isCallBack\":\"N\",\"clickcallback\":\"N\",\"shareActionType\":\"S\",\"mpId\":\"\",\"mpPath\":\"\",\"mpIconUrl\":\"\",\"mpType\":\"1\"}");
    (0, seoLocationWatcher_1.getLocation)().href = url;
}
exports.jdhshare = jdhshare;
// 京东医生app分享
/**
 * 通过 默认方式设置 分享按钮显示 & 分享信息设置
 */
function jdDoctor(options, optionsTmp) {
    return __awaiter(this, void 0, void 0, function () {
        /**
         *  由于京东医生app 主页预览增加 了onlyPreview 参数导致分享不能走下单流程
         *  需要手动去除
         *  useNewJdDoctorCommonWebViewPlugin, sid 两个参数 京东医生app内使用
         *  链接：https://m.healthjd.com/s/EvaluationManage/DoctorDetail?doctorId=257510967510&onlyPreview=1&useNewJdDoctorCommonWebViewPlugin=1&sid=b8f8283432805d52a5768b0da33c034w
         */
        function pinJieUrl(url) {
            var URL = url;
            if (url) {
                var urlArr = url.split("?");
                // 参数处理成对象 过滤对象
                urlArr[1] = urlArr[1].replace("&onlyPreview=1", "");
                // urlArr[1] = urlArr[1].slice(0, urlArr[1].indexOf('&onlyPreview=1'));
                URL = "".concat(urlArr[0], "?").concat(urlArr[1]);
            }
            return URL;
        }
        var params, UA, iconSrc, jsonString, obj, jssdk, version, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = Object.assign({}, optionsTmp, options);
                    UA = navigator.userAgent;
                    iconSrc = "https://m.360buyimg.com/pop/jfs/t1/156052/19/11311/1503/6037428eE18cfe79a/3710a911f1a3a730.png";
                    params.shareUrl = pinJieUrl(params.shareUrl);
                    jsonString = JSON.stringify({
                        type: "share",
                        display: "show", //show, hide
                        position: "outside",
                        icon: iconSrc,
                        blackIcon: iconSrc, // 分享图标
                        jump: "openapp.jddoctor://virtual?params={\"category\":\"jump\",\"des\":\"share\",\"type\":\"111\",\"title\":\"".concat(params.title, "\",\"content\":\"").concat(params.content, "\",\"shareUrl\":\"").concat(params.shareUrl, "\",\"imageUrl\":\"").concat(params.imageUrl, "\",\"iconUrl\":\"").concat(params.iconUrl, "\",\"timeline_title\":\"\",\"qrparam\":null,\"keyparam\":null,\"channel\":\"Wxfriends,Wxmoments\",\"isCallBack\":\"N\",\"clickcallback\":\"N\",\"shareActionType\":\"S\",\"mpId\":\"\",\"mpPath\":\"\",\"mpIconUrl\":\"\",\"mpType\":\"1\"}"),
                    });
                    obj = {
                        method: "configBtn",
                        params: jsonString,
                    };
                    return [4 /*yield*/, (0, jssdk_1.getJssdk)()];
                case 1:
                    jssdk = _a.sent();
                    if (jssdk.JSSDK.Client.isIOS()) {
                        version = getVersion();
                        if (Version(version, "2.1.7")) {
                            url = "openapp.jddoctor://virtual?params={\"category\":\"jump\",\"des\":\"share\",\"type\":\"111\",\"title\":\"".concat(params.title, "\",\"content\":\"").concat(params.content, "\",\"shareUrl\":\"").concat(params.shareUrl, "\",\"imageUrl\":\"").concat(params.imageUrl, "\",\"iconUrl\":\"").concat(params.iconUrl, "\",\"timeline_title\":\"\",\"qrparam\":null,\"keyparam\":null,\"channel\":\"Wxfriends,Wxmoments\",\"isCallBack\":\"N\",\"clickcallback\":\"N\",\"shareActionType\":\"S\",\"mpId\":\"\",\"mpPath\":\"\",\"mpIconUrl\":\"\",\"mpType\":\"1\"}");
                            (0, seoLocationWatcher_1.getLocation)().href = url;
                        }
                    }
                    else {
                        // 安卓
                        jssdk.MobileNavi && jssdk.MobileNavi.configBtn(jsonString);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.jdDoctor = jdDoctor;
function share() {
    return __awaiter(this, arguments, void 0, function (options) {
        var optionsTmp, agent;
        var _this = this;
        if (options === void 0) { options = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionsTmp = {
                        // 分享相关的还在wx.js中涉及
                        title: exports.wxShareInfo.title,
                        content: exports.wxShareInfo.content,
                        shareUrl: "https://m.healthjd.com/s/",
                        channel: "Wxfriends,Wxmoments,Sinaweibo,QQfriends,QQzone",
                        imageUrl: exports.wxShareInfo.imageUrl,
                        iconUrl: exports.wxShareInfo.imageUrl,
                    };
                    agent = navigator.userAgent.toLowerCase();
                    // 在京东健康app内
                    if (agent.indexOf("jdhapp") > -1) {
                        jdhshare(options, optionsTmp);
                        return [2 /*return*/];
                    }
                    if (!(agent.indexOf("jddoctor") > -1)) return [3 /*break*/, 2];
                    return [4 /*yield*/, jdDoctor(options, optionsTmp)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2:
                    if (agent.indexOf("jdapp") < 0)
                        return [2 /*return*/]; // 不在京东app内
                    try {
                        // window.JSSDK.WebView.resetConfigBtn();
                        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            var jssdk;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, (0, jssdk_1.getJssdk)()];
                                    case 1:
                                        jssdk = _a.sent();
                                        jssdk.JSSDK.WebView.callHeaderSharePanel(Object.assign({}, optionsTmp, options));
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 0);
                    }
                    catch (error) {
                        // console.error('share error:', error);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.share = share;
